import { Directive, ElementRef, Host, HostListener, Input, OnInit, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[appNumericInput]',
  standalone: false,
})
export class NumericInputDirective implements OnInit {
  @Input() minValue: number;
  @Input() maxValue: number;
  @Input() decimals = 0;
  @Input() allowNegative: boolean;
  @Input() allowFractional: boolean;
  @Input() keepLastValid = true;

  normalRegex: RegExp;
  fractionalRegex: RegExp;

  lastValid;

  constructor(
    private elementRef: ElementRef,
    @Host() @Optional() private inputControl: NgControl
  ) {}

  ngOnInit() {
    this.lastValid = this.elementRef.nativeElement.value;
    let regexString = `[^0-9${this.allowNegative ? '-' : ''}]`;

    if (this.allowFractional) {
      this.fractionalRegex = new RegExp(
        `^${this.allowNegative ? '(\\-){0,1}' : ''}(0|[1-9]\\d*)(\\.\\d{1,${
          this.decimals > 0 ? this.decimals : ''
        }})?$`
      );
      regexString = `[^0-9.${this.allowNegative ? '-' : ''}]`;
    }

    this.normalRegex = new RegExp(regexString, 'g');
  }

  @HostListener('input') onInputChange() {
    function insertAt(str, index, replacement) {
      return str.substr(0, index) + replacement + str.substr(index);
    }

    const initialValue = this.elementRef.nativeElement.value;

    let value: string = initialValue.replace(this.normalRegex, '');

    const lastNegative = value.indexOf('-', 1);
    if (lastNegative > 0) {
      value = value.slice(0, lastNegative) + value.slice(lastNegative + 1).replace('-', '');
    }

    if (this.allowFractional) {
      // Keep only the first decimal point
      const firstIdx = value.indexOf('.');
      const lastIdx = value.lastIndexOf('.');
      if (firstIdx !== lastIdx) {
        value = value.replace(/\./g, '');
        value = insertAt(value, firstIdx, '.');
      }

      // Strip extra fractional digits after the max number of decimals
      if (firstIdx !== -1 && this.decimals > 0 && !(value.startsWith('.') || value.endsWith('.'))) {
        const extraDigitsAfterDecimal = value.substring(firstIdx + 1 + this.decimals).length;

        if (extraDigitsAfterDecimal > 0) {
          value = value.substr(0, value.length - extraDigitsAfterDecimal);
        }
        this.lastValid = value;
      }
    }

    this.elementRef.nativeElement.value = value;
    if (this.inputControl) {
      this.inputControl.control.setValue(value);
    }
  }

  @HostListener('focus', ['$event']) onInputFocus(_event) {
    if (!this.lastValid) {
      this.lastValid = this.elementRef.nativeElement.value;
    }
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('blur', ['$event'])
  onInputBlur(_event) {
    if (this.fractionalRegex) {
      if (this.keepLastValid && !this.fractionalRegex.test(this.elementRef.nativeElement.value)) {
        this.elementRef.nativeElement.value = this.lastValid;
      }
    }

    let value = this.elementRef.nativeElement.value;

    if (this.elementRef.nativeElement.value !== '') {
      if (typeof this.minValue === 'number' && +value < this.minValue) {
        value = this.minValue;
      } else if (typeof this.maxValue === 'number' && +value > this.maxValue) {
        value = this.maxValue;
      }
    }

    this.elementRef.nativeElement.value = value;
    if (this.inputControl) {
      this.inputControl.control.setValue(value);
    }
  }
}
